import { Calendar, DocumentText, Box, TickCircle, WalletMoney } from "iconsax-react";

export const REQUEST_AUDIT_ACTION_LABEL_MAP: Record<string, string> = {
  "annual_leave.created": "audit.actions.leaveCreated",
  "annual_leave.updated": "audit.actions.leaveUpdated",
  "annual_leave.rejected": "audit.actions.leaveRejected",
  "annual_leave.revision_requested": "audit.actions.leaveRevisionRequested",
  "annual_leave.submitted_for_signing": "audit.actions.leaveSubmittedForSigning",
  "annual_leave.application_signed_org": "audit.actions.leaveApplicationSignedOrg",
  "annual_leave.application_signed_employee": "audit.actions.leaveApplicationSignedEmployee",
  "annual_leave.cancelled": "audit.actions.leaveCancelled",
  "annual_leave.order_created": "audit.actions.orderCreated",
  "annual_leave.order_signed_org": "audit.actions.orderSignedOrg",
  "annual_leave.order_acknowledged": "audit.actions.leaveOrderAcknowledged",
  "annual_leave.activated": "audit.actions.leaveActivated",
  "annual_leave.completed": "audit.actions.leaveCompleted",

  "unpaid_leave.created": "audit.actions.leaveCreated",
  "unpaid_leave.updated": "audit.actions.leaveUpdated",
  "unpaid_leave.rejected": "audit.actions.leaveRejected",
  "unpaid_leave.revision_requested": "audit.actions.leaveRevisionRequested",
  "unpaid_leave.submitted_for_signing": "audit.actions.leaveSubmittedForSigning",
  "unpaid_leave.application_signed_org": "audit.actions.leaveApplicationSignedOrg",
  "unpaid_leave.application_signed_employee": "audit.actions.leaveApplicationSignedEmployee",
  "unpaid_leave.cancelled": "audit.actions.leaveCancelled",
  "unpaid_leave.order_created": "audit.actions.orderCreated",
  "unpaid_leave.order_signed_org": "audit.actions.orderSignedOrg",
  "unpaid_leave.order_acknowledged": "audit.actions.leaveOrderAcknowledged",
  "unpaid_leave.activated": "audit.actions.leaveActivated",
  "unpaid_leave.completed": "audit.actions.leaveCompleted",

  "medical_leave.created": "audit.actions.leaveCreated",
  "medical_leave.updated": "audit.actions.leaveUpdated",
  "medical_leave.rejected": "audit.actions.leaveRejected",
  "medical_leave.revision_requested": "audit.actions.leaveRevisionRequested",
  "medical_leave.submitted_for_signing": "audit.actions.leaveSubmittedForSigning",
  "medical_leave.application_signed_org": "audit.actions.leaveApplicationSignedOrg",
  "medical_leave.application_signed_employee": "audit.actions.leaveApplicationSignedEmployee",
  "medical_leave.cancelled": "audit.actions.leaveCancelled",
  "medical_leave.certificate_uploaded": "audit.actions.certificateUploaded",
  "medical_leave.order_created": "audit.actions.orderCreated",
  "medical_leave.order_signed_org": "audit.actions.orderSignedOrg",
  "medical_leave.order_acknowledged": "audit.actions.leaveOrderAcknowledged",
  "medical_leave.activated": "audit.actions.leaveActivated",
  "medical_leave.completed": "audit.actions.leaveCompleted",
  "medical_leave.acknowledged": "audit.actions.medicalAcknowledged",
  "medical_leave.closed": "audit.actions.medicalClosed",
  "medical_leave.sick_note_uploaded": "audit.actions.medicalSickNoteUploaded",
  "medical_leave.dates_updated": "audit.actions.medicalDatesUpdated",

  "amendment.created": "audit.actions.amendmentCreated",
  "amendment.updated": "audit.actions.amendmentUpdated",
  "amendment.deleted": "audit.actions.amendmentDeleted",
  "amendment.rejected": "audit.actions.amendmentRejected",
  "amendment.revision_requested": "audit.actions.amendmentRevisionRequested",
  "amendment_application.submitted_for_signing": "audit.actions.amendmentApplicationSubmitted",
  "amendment.application_signed": "audit.actions.amendmentApplicationSigned",
  "amendment_order.esigned": "audit.actions.amendmentOrderEsigned",
  "amendment_agreement.submitted_for_signing": "audit.actions.amendmentAgreementSubmitted",
  "amendment.agreement_signed": "audit.actions.amendmentAgreementSigned",
  "amendment.applied": "audit.actions.amendmentApplied",
  "amendment.cancelled": "audit.actions.amendmentCancelled",

  "resignation.rejected": "audit.actions.resignationRejected",
  "resignation.revision_requested": "audit.actions.resignationRevisionRequested",
  "resignation.updated": "audit.actions.resignationUpdated",
  "resignation.deleted": "audit.actions.resignationDeleted",
  "resignation.submitted_for_signing": "audit.actions.resignationSubmittedForSigning",
  "resignation_letter.application_signed_org": "audit.actions.resignationApplicationSignedOrg",
  "resignation_letter.application_signed_employee": "audit.actions.resignationApplicationSignedEmployee",
  "resignation_letter.cancelled": "audit.actions.resignationCancelled",
  "resignation_letter.order_signed_org": "audit.actions.resignationOrderSignedOrg",
  "resignation_letter.order_acknowledged": "audit.actions.resignationOrderAcknowledged",
  "termination_order.created": "audit.actions.terminationOrderCreated",
  "termination_order.esigned": "audit.actions.terminationOrderEsigned",

  "unit_request.created": "audit.actions.itemRequestCreated",
  "unit_request.approved": "audit.actions.itemRequestApproved",
  "unit_request.rejected": "audit.actions.itemRequestRejected",
  "unit_request.cancelled": "audit.actions.itemRequestCancelled",
  "unit_request.fulfilled": "audit.actions.itemRequestFulfilled",
  "unit_request.unavailable": "audit.actions.itemRequestUnavailable",

  "completion_act.signed": "audit.actions.completionActSigned",
  "completion_act.approved": "audit.actions.completionActApproved",
  "completion_act.rejected": "audit.actions.completionActRejected",
  "completion_act.revoked": "audit.actions.completionActRevoked",
  "completion_act.terminated": "audit.actions.completionActTerminated",
  "completion_act.termination_initiated": "audit.actions.completionActTerminationInitiated",
  "completion_act.termination_rejected": "audit.actions.completionActTerminationRejected",
  "completion_act.refused": "audit.actions.completionActRefused",

  "personal_data_change.created": "audit.actions.dataChangeCreated",
  "personal_data_change.hr_approved": "audit.actions.dataChangeHrApproved",
  "personal_data_change.hr_rejected": "audit.actions.dataChangeHrRejected",
  "personal_data_change.chief_approved": "audit.actions.dataChangeChiefApproved",
  "personal_data_change.chief_rejected": "audit.actions.dataChangeChiefRejected",
  "personal_data_change.applied": "audit.actions.dataChangeApplied",
  "personal_data_change.chief_applied": "audit.actions.dataChangeChiefApplied",

  "advance.created": "audit.actions.advanceCreated",
  "advance.reviewed": "audit.actions.advanceReviewed",
  "advance.approved": "audit.actions.advanceApproved",
  "advance.issued": "audit.actions.advanceIssued",
  "advance.resubmitted": "audit.actions.advanceResubmitted",
  "advance.deleted": "audit.actions.advanceDeleted",
  "salary_advance.submitted_for_signing": "audit.actions.advanceSubmittedForSigning",
  "salary_advance.signed": "audit.actions.advanceSignedByChief",
};

export const REQUEST_AUDIT_ICON_MAP: Record<string, React.ComponentType<{ size: number; color: string }>> = {
  annual_leave: Calendar,
  unpaid_leave: Calendar,
  medical_leave: Calendar,
  amendment: DocumentText,
  amendment_application: DocumentText,
  amendment_order: DocumentText,
  amendment_agreement: DocumentText,
  resignation: DocumentText,
  resignation_letter: DocumentText,
  termination_order: DocumentText,
  unit_request: Box,
  completion_act: TickCircle,
  personal_data_change: DocumentText,
  advance: WalletMoney,
  salary_advance: WalletMoney,
};
